<template>
  <div class="third">
    <div class="third-formOne adhibition">
      <div class="formOne-btn">
        <div class="btn-left">
          <!-- <span class="left-back-icon" @click="goBack">
            <i class="el-icon-arrow-left"></i>
            <span class="left-back-title">返回</span>
          </span>
          <span class="left-back-shu">
            <span class="left-back-shu-content"></span>
          </span>-->
          <span class="left-back-content">登录账号提示配置</span>
          <!-- <span v-if="IDlist !== ''" class="left-back-content">编辑班级信息</span> -->
        </div>
        <div class="btn-right">
          <el-button @click="ruleFormFN()" class="btn-two" type="default">重置</el-button>
          <el-button
            @click="saveLoginAccountTipsFN()"
            class="btn-two"
            type="primary"
            v-el-disabel-repeat-click
          >保存</el-button>
        </div>
      </div>
      <el-form :show-message="false"  style="width:60%;float:left" label-width="86px">
        <div class="formOne-forms">
          <div class="forms-one" style="margin-top: 57px;">
            <div class="one-list">
              <el-form :model="valueDate" :rules="rules" ref="valueDate" label-width="86px">
                <div class="list-two-line">
                  <el-form-item label="账号提示(中文)" prop="value">
                    <el-input
                      class="list-textarea"
                      type="textarea"
                      placeholder="请输入"
                      maxlength="200"
                      v-model.trim="valueDate.value"
                    ></el-input>
                  </el-form-item>
                </div>
                <div class="list-two-line">
                  <el-form-item label="账号提示(英文)" prop="valueEn">
                    <el-input
                      class="list-textarea"
                      type="textarea"
                      placeholder="不填默认使用中文版内容"
                      maxlength="1000"
                      v-model="valueDate.valueEn"
                    ></el-input>
                  </el-form-item>
                </div>
                <!-- <div class="list-two-line">
                  <el-form-item label="忘记密码链接" prop="password" style="margin-top:20px">
                    <el-input
                      class="list-input"
                      :maxlength="500"
                      v-model.trim="valueDate.password"
                      placeholder="请完整输入http(s)"
                    ></el-input>
                  </el-form-item>
                </div>
                <div class="list-two-line">
                  <el-form-item label="" prop="valueEn">
                    <span style='font-size:12px;color:rgba(46, 63, 87, 0.749019607843137)'>
                      备注：如果未填写任何内容，则用户端不会展示忘记密码和账号提示
                    </span>
                  </el-form-item>
                </div> -->
              </el-form>
            </div>
          </div>
        </div>
      </el-form>
      <div class="phon-right">
        <img class="phon-right-img" src="@/assets/dltp1.png" alt />
      </div>
    </div>
  </div>
</template>

<script>
import {
  LoginAccountTips,
  saveLoginAccountTips
} from "@/store/appconfig/Login-prompt"; //我的

export default {
  name: "formSeven",
  data () {
    return {
      countNum: 1,
      rules: {
        password: [
          { type: "string", pattern: /^http[s]?:\/\/.*/, message:"请完整输入http(s)", trigger: blur}
        ]
      },

      //---------------------------------------

      valueDate: {
        value:"",
        valueEn:"",
        password: ""
      } //初始提示语
    };
  },
  created () {
    this.LoginAccountTipsFN();
  },
  methods: {
    // 验证
    validateValue (prop, msgStatus, validateMessage) {
      if (!this.countNum && !msgStatus) {
        this.countNum += 1;
        if (validateMessage) {
          this.$message.error(validateMessage);
        }
      }
    },
    //重置
    ruleFormFN () {
      this.LoginAccountTipsFN();
    },
    //获取提示
    LoginAccountTipsFN () {
      try {
        LoginAccountTips().then(res => {
          const data = res.data;
          // console.log("获取提示", res);
          if (data.status === 1000) {
            this.valueDate.value = data.result.login.value;
            this.valueDate.valueEn = data.result.login.valueEn;
            this.valueDate.password = data.result.password;
          }else {
            this.$message({
              type: "error",
              message: data.msg
            });
          }
        });
      } catch (err) {
        console.log(err);
      }
    },
    //保存
    saveLoginAccountTipsFN() {
      try {
        const params = {
          value: this.valueDate.value, //账号提示（中文）
          valueEn: this.valueDate.valueEn, //账号提示（英文）
          password: this.valueDate.password
        };
        saveLoginAccountTips(params).then(res => {
          const data = res.data;
          if(data.status===1000){
            this.$message.success("操作成功")
          }else {
            this.$message({
              type: "error",
              message: data.msg
            });
          }
          });
        } catch (err) {
        console.log(err);
      }
    }
  }
};
</script>
<style lang="scss">
.phon-right {
  position: relative;
  // border:1px solid red;
  width: 40%;
  display: inline-block;
  height: calc(100vh - 102px);
  border-left: 1px solid #dcdee2;
  img {
    // border: 1px solid red;
    width: 389px;
    height: 669px;
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
  }
}
</style>
